import {Component, Input, OnInit, SimpleChanges, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { IGAEADLookupService } from 'app/shared/services/igaead-lookup.service';
import { IGAEADMeetingsService } from 'app/shared/services/igaead-meetings.service';
import { EnvironmentLoader } from 'environments/utils/environment-loader.util';

declare const moment: any;

@Component({
    selector: 'app-meeting-details',
    templateUrl: './meeting-details.component.html',
    styleUrls: ['./meeting-details.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MeetingDetailsComponent implements OnInit {

    @Input() meeting;
    @Input() filterText;
    @Input() expandAll;
    @Input() expand;
    @Input() lastVisitTime;
    currentSession;
    currentDoc;
    currentBody;
    evotes= [];
    singleEvote;
    selectedVotes=[];
    selectedSponsor=[];
    selectedType ='';
    titleTextYes;
    titleTextNo;
    titleTextAbstain;
    showVotes=false;
    panelOpenState = false;
    showSponsorship = false;
    mainBody=''
    constructor(private router: Router,
      private currentRoute: ActivatedRoute,
      private meetingService: IGAEADMeetingsService,
        private lookupService: IGAEADLookupService) {
    }

    ngOnInit(): void {
      this.currentSession = this.currentRoute.snapshot.paramMap.get('sessionID');
      this.currentDoc = this.currentRoute.snapshot.queryParamMap.get('document');
      this.currentBody = (this.currentRoute.snapshot.paramMap.get('body') || "plenary").replace('.', '').toLowerCase();
      this.mainBody = this.router.url.split('/')[1];
      if(this.expandAll){
        this.panelOpenState =true;
      }
      else if(this.meeting.isDocExist){
        this.panelOpenState =true;
      }
    }

    ngOnChanges(changes: SimpleChanges): void {
      if(this.expandAll){
        this.panelOpenState =true;
      }else{
        this.panelOpenState =false;
      }
    }

    checkMeetingChanges(meeting){
      if (!meeting.MT_UpdatedOn) return false;
      const meetingUpdatedOn = moment(meeting.MT_UpdatedOn);
      const compareTime = moment().subtract(24, 'hours');
      if (!compareTime.isValid()) return false;

      if (meetingUpdatedOn.isAfter(compareTime)) {
        return true;
      }
      return false;

      // let dateValidation = new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString();
      // if(meeting.MT_UpdatedOn && meeting.MT_UpdatedOn > this.lastVisitTime && this.lastVisitTime > dateValidation){
      // if (meeting.MT_UpdatedOn && meeting.MT_UpdatedOn > dateValidation) {
      //   return true;
      // }
      // return false;
    }

    public openPage(name: string): void {
        this.router.navigate([name], {});
    }

    symbolOnly(input) {
      if (input != null) return input.replace(/ (DR|DD).*/, '');
    }

    getWasPrefix(step){
      if(step.PS_type && step.PS_type.label == 'Motion'){
        return true;
      }
      if(step.PS_type && step.PS_type.label == 'Request for separate votes (motion to divide)'){
        return true;
      }
      return false
    }

    wasAdoptedText(step, isNot, withoutWas= true){
      if(step.PS_type &&  step.PS_type.label=='Action (unnumbered decision)' && this.checkTag(step.PS_tags, 'Oral decision')){
        return '';
      }
      if(step.PS_outcome =='WITHDRAWN' && withoutWas){
        return 'withdrawn'
      }
      if(step.PS_outcome =='WITHDRAWN' && !withoutWas){
        return 'was withdrawn'
      }
      if(step.PS_outcome =='ADOPTED' && withoutWas){
        return 'adopted'
      }
      if(step.PS_outcome =='ADOPTED' && !withoutWas){
        return 'was adopted'
      }
      if(step.PS_outcome !='ADOPTED' && withoutWas){
        return 'not adopted'
      }
      if(step.PS_outcome !=='ADOPTED' && !withoutWas){
        return 'was not adopted'
      }
      return 'was adopted';
    }

    isSummaryEnabled(){
      console.log('this.currentBody', this.currentBody);
      const enabled = ['c2', 'c3', 'c4', 'c5'].includes(this.currentBody)
      return enabled;
    }

    getPatargraph(step, segment){
      if(step.PS_type && step.PS_type.label == 'Document taken note of'){
        let docType =[];
        let docSymbol =[];
        for(let doc of step.PS_selectDocumentFromWorkPackage){
          docType.push(doc.DD_documentType);
          if((step.PS_outcome =='ADOPTED' || step.PS_outcome =='NOT-ADOPTED') && doc.DD_symbol1.indexOf('L.')){
            docSymbol.push(`<a href="https://undocs.org/${this.symbolOnly(doc.DD_symbol1)}" aria-label="${doc.DD_symbol1}" target="_blank">${doc.DD_symbol1}</a><a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" style="color: #151E3D;" aria-label="${doc.DD_symbol1}"> <i class="fa fa-external-link"></i></a> <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" style="color: #151E3D;" aria-label="${doc.DD_symbol1}"> <i class="fa fa-external-link"></i></a> <button class="btn btn-outline-secondary sponsor-btn" data-action="sponsorship" data-document="${doc.DD_symbol1}">S</button>`)
          }
          else{
            docSymbol.push(`<a href="https://undocs.org/${this.symbolOnly(doc.DD_symbol1)}" aria-label="${doc.DD_symbol1}" target="_blank">${doc.DD_symbol1}</a><a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" style="color: #151E3D;" aria-label="${doc.DD_symbol1}"> <i class="fa fa-external-link"></i></a>`);
          }
          //console.log('calling here2333',`[Document type] ${doc.DD_symbol1} was taken note of (decision ${step.PS_recordDecisionNumber})`);
        }
        //console.log(`${docType.join(', ')} ${docSymbol.join(', ')} was taken note of (decision ${step.PS_recordDecisionNumber})`)
        //return `${docType.join(', ')} ${docSymbol.join(', ')} was taken note of (decision ${step.PS_recordDecisionNumber})`;
        return `${docType.join(', ')} ${docSymbol.join(', ')} was taken note of ${step.PS_recordDecisionNumber ? '(decision '+step.PS_recordDecisionNumber+')': ''}`;
      }
      if(step.PS_type && step.PS_type.label == 'Motion'){
        return `Motion: ${step.PS_text1}`;
      }
      if(step.PS_type && step.PS_type.label == 'Request for separate votes (motion to divide)'){
        return 'Separate votes (motion to divide) ';
      }
      if(step.PS_operativeParagraphs && step.PS_operativeParagraphs.length > 0) {
        return `Operative paragraph ${step.PS_operativeParagraphs[0].value} of draft resolution`;
      }
      if(step.PS_type && step.PS_type.label.indexOf('Action') > -1 && step.PS_selectDocumentFromWorkPackage.length ==0 && (segment.MTS_selectDocumentFromWorkPackage && segment.MTS_selectDocumentFromWorkPackage.length ==0 || segment.MTS_selectDocumentFromWorkPackage.length > 1) &&  step.PS_text1 != ""){
        return step.PS_text1
      }
      if(step.PS_type && step.PS_type.label.indexOf('Action') > -1 && step.PS_selectDocumentFromWorkPackage.length ==0 &&  (!step.PS_text1 || step.PS_text1 == "")){
        return '';
      }
      if(step.PS_type && step.PS_type.label.indexOf('Action on amendment') > -1){
        return 'Amendment   ';
      }
      if(step.PS_preambularParagraphs && step.PS_preambularParagraphs.length > 0){
        return `Preambular paragraph ${step.PS_preambularParagraphs[0].value} of draft resolution`;
      }
      if(step.PS_type && step.PS_type.label.indexOf('Statement to orally change') > -1 && step.PS_oralChanges.indexOf('Oral amendment') > -1){
        let type="";
        if(this.checkDocument(step.PS_selectDocumentFromWorkPackage)){
          type= step.PS_selectDocumentFromWorkPackage[0].DD_documentType;
        }
        return `Oral amendment to ${type} `;
      }
      if(step.PS_type && step.PS_type.label.indexOf('Statement to orally change') > -1 && step.PS_oralChanges.indexOf('Oral revision') > -1){
        let type="";
        if(this.checkDocument(step.PS_selectDocumentFromWorkPackage)){
          type= step.PS_selectDocumentFromWorkPackage[0].DD_documentType;
        }
        return `Oral revision to ${type} `;
      }
      if(step.PS_type && step.PS_type.label.indexOf('Statement to orally change') > -1 && step.PS_oralChanges.indexOf('Oral correction') > -1){
        let type="";
        if(this.checkDocument(step.PS_selectDocumentFromWorkPackage)){
          type= step.PS_selectDocumentFromWorkPackage[0].DD_documentType;
        }
        return `Oral correction to ${type} `;
      }
      if(step.PS_type &&  step.PS_type.label=='Action (unnumbered decision)' && this.checkTag(step.PS_tags, 'Oral decision')){
        return step.PS_text1 + ' ' + step.PS_text2 + ' ' + step.PS_text3;
      }
      if(this.checkDocument(step.PS_selectDocumentFromWorkPackage)){
        return step.PS_selectDocumentFromWorkPackage[0].DD_documentType;
      }
    }

    checkDocument(steps){

      for(let step of steps){
        if(step.DD_documentType){
          return true;
        }
      }
      return false;
    }
    getAddoption(step) {
      if(step.PS_recordResolutionNumber){
        if(this.mainBody =='ecosoc'){
          return `(resolution <a href="https://www.undocs.org/E/RES/${step.PS_recordResolutionNumber}" target="_blank" >${step.PS_recordResolutionNumber}</a>)`;  
        }
        return `(resolution <a href="https://www.undocs.org/A/RES/${step.PS_recordResolutionNumber}" target="_blank" >${step.PS_recordResolutionNumber}</a>)`;
      }
      else if(step.PS_recordDecisionNumber){
        return '(decision' + step.PS_recordDecisionNumber +')';
      }
      return '';
    }

    getDate(params){
        let date = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us',{ weekday:"long", month:"long", day:"numeric", year:"numeric", hour:"numeric", minute:"numeric"});
        let dayName = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us',{ weekday:"long" });
        let day = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us',{ day:"numeric" });
        let month = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us',{ month:"long" });
        let year = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us',{ year:"numeric" });
        let hour = new Date(params.MT_dateTimeScheduleStart).toLocaleTimeString('en-us',{ hour:"2-digit" }).split(' ');

        let minutes = new Date(params.MT_dateTimeScheduleStart).toLocaleTimeString('en-us',{ minute:"2-digit" });
        minutes = minutes === '0' ? '00' : minutes;
        //let date = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us',{ hour:"numeric", minute:"numeric"});
        //date = pipe.transform(date, 'EEEE, dd MMMM Y, h:m a');
        //let _date = date.getDate() + ' ' + date.getDate()
        let title = '';
        let venue = '';
        if(params.MT_name!=""){
          title = " - "+ params.MT_name;
        }
        if(params.MT_room!=""){
          venue = params.MT_room ? " - " + params.MT_room : '';
        }
        if(params.MT_body=='GA' && params.MT_type=='Formal meeting' && params.MT_room ==''){
          venue = ' - General Assembly Hall';
        }
        let endHour = '';
        if(hour[0] == '10' && params.MT_dateTimeScheduleEnd){
          let hour = new Date(params.MT_dateTimeScheduleEnd).toLocaleTimeString('en-us',{ hour:"2-digit" }).split(' ');
          endHour = hour[0] == '06' ? ' and 3:00 PM ' : '';
        }

        return `${dayName +', '+ day + ' ' + month + ' ' + year +', '+ hour[0] + ':' + minutes + " "+ hour[1]  + endHour + title + venue }`;
        //return `${date + " " + params.MT_body}`;
    }
    handleClick(event: Event): void {
      const target = event.target as HTMLElement;

      if (target.tagName === 'BUTTON') {
        const action = target.getAttribute('data-action');
        if (action === 'sponsorship') {
          const document = target.getAttribute('data-document');
          this.getSponsorship(document);
        }
      }
    }
    getTitle(segment){
        let title = segment.MTS_segmentTitle || '';
        const bracketCheckRegx = /\(/;
        for(let MTS_agenda of segment.MTS_agenda){
          let code:RegExp , code1:RegExp;
          let onlyItemRegx = new RegExp(`\\b${MTS_agenda.item.toLowerCase()}\\b(?![(])`)
          if(bracketCheckRegx.test(MTS_agenda.item)){
            code = new RegExp('Item ' +  MTS_agenda.item.replace(/([()])/g, "\\$1"));
            code1 = new RegExp('item ' +  MTS_agenda.item.replace(/([()])/g, "\\$1"));
            title =  title.replace(code, `<a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
            title =  title.replace(code1, `<a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
          }
          else if(onlyItemRegx.test(title.toLowerCase())){
            code = new RegExp('Item ' +  MTS_agenda.item.replace(/([()])/g, "\\$1"));
            code1 = new RegExp('item ' +  MTS_agenda.item.replace(/([()])/g, "\\$1"));
            title =  title.replace(code, `<a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
            title =  title.replace(code1, `<a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
          }

          // //let code = new RegExp(`\\bItem ${MTS_agenda.item}\\b(?![(])`);
          // //let code1 = new RegExp(`\\bitem ${MTS_agenda.item}\\b(?![(])`);

          // if(code.test(MTS_agenda.item)){
          //   code = new RegExp('Item ' +  MTS_agenda.item.replace(/([()])/g, "\\$1"));
          //   code1 = new RegExp('item ' +  MTS_agenda.item.replace(/([()])/g, "\\$1"));
          // }
          // console.log(code,code1);
          // //let code = new RegExp(`\\bItem ` +  MTS_agenda.item.replace(/([()])/g, "\\$1")+"\\b",'g');
          // console.log('code', code);
          // title =  title.replace(code, `<a href="${EnvironmentLoader.environment.localURL}/ga/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
          // //console.log('code 1', code);
          //let code1 = new RegExp(`^item ${MTS_agenda.item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'g');
          //let code1 = new RegExp('item ' + MTS_agenda.item.replace(/([()])/g, "\\$1"));

          //title =  title.replace(code1, `<a href="${EnvironmentLoader.environment.localURL}/ga/${this.currentBody}/${this.currentSession}/${MTS_agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + MTS_agenda.item}">${'Item ' + MTS_agenda.item}</a>`)
        }
        const seenSymbols = new Set<string>();
        for(let doc of segment.MTS_selectDocumentFromWorkPackage){
          if(seenSymbols.has(doc.DD_symbol1)){
            continue;
          }
          seenSymbols.add(doc.DD_symbol1);
          //let code = new RegExp(doc.DD_symbol1)
          let code = new RegExp(`(?:\\W|^)${doc.DD_symbol1}(?:\\W|$)`);
          title =  title.replace(code, ` <a href="https://undocs.org/${this.symbolOnly(doc.DD_symbol1)}" aria-label="${doc.DD_symbol1}" target="_blank">${doc.DD_symbol1}</a> <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" aria-label="${doc.DD_symbol1}" ><i class="fa fa-external-link"></i></a> `)
        }
        //console.log('title', title);
        return title;
    }

    getDocumentTitle(documents, step, seqNo){

      if(step.PS_type && step.PS_type.label =='Document before it' && step.PS_Public=='Yes'){
        let title =[];
        for(let document of step.PS_selectDocumentFromWorkPackage){
          let docTitle = document.DD_officialTitle;
          if(!docTitle){
            docTitle = document.DD_workingTitle;
          }
          title.push(`- ${docTitle} (<a href="https://undocs.org/${this.symbolOnly(document.DD_symbol1)}" aria-label="${document.DD_symbol1}" target="_blank">${document.DD_symbol1}</a>) <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${document.DD_symbol1}" aria-label="${document.DD_symbol1}" ><i class="fa fa-external-link"></i></a>`);
        }
        return title.join('<br/>')
      }
      return ''
    }

    getDocument(docs, adopted=''){
      let title = [];
      if(docs){
        for(let doc of docs){
          if((adopted =='ADOPTED' || adopted =='NOT-ADOPTED') && doc.DD_symbol1.indexOf('L.')){
            title.push(`<a href="https://undocs.org/${this.symbolOnly(doc.DD_symbol1)}" target="_blank" style="color: #151E3D;" aria-label="${doc.DD_symbol1}">${doc.DD_symbol1}</a> <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" style="color: #151E3D;" aria-label="${doc.DD_symbol1}"> <i class="fa fa-external-link"></i></a>  <button class="btn btn-outline-secondary sponsor-btn" data-action="sponsorship" data-document="${doc.DD_symbol1}">S</button>`)
          }
          else{
            title.push(`<a href="https://undocs.org/${this.symbolOnly(doc.DD_symbol1)}" target="_blank" style="color: #151E3D;" aria-label="${doc.DD_symbol1}">${doc.DD_symbol1}</a> <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${doc.DD_symbol1}" style="color: #151E3D;" aria-label="${doc.DD_symbol1}"> <i class="fa fa-external-link"></i></a>`)
          }
        }
      }
      return title.join(', ');
  }

    journalUrl(MT_JCMSMeetingID){
      return EnvironmentLoader.environment.journalUrl + MT_JCMSMeetingID
    }

    checkIsDiscussion(step) {
      return step.PS_tags.includes(EnvironmentLoader.environment.generalDiscussionTagId);
    }

    pvLink(meetingNo){
      if(this.currentBody == 'c1'){
        return `https://docs.un.org/A/C.1/${this.currentSession}/PV.${meetingNo}`
      }
      if(this.mainBody.toLowerCase() == 'ecosoc'){
        return `https://undocs.org/E/${this.currentSession}/PV.${meetingNo}`  
      }
      return `https://undocs.org/A/${this.currentSession}/PV.${meetingNo}`
    }

    svLink(meetingNo){
      if(this.mainBody.toLowerCase() == 'ecosoc'){
        return `https://undocs.org/E/${this.currentSession}/SR.${meetingNo}`
      }
      return `https://undocs.org/A/C.${this.currentBody.slice(1)}/${this.currentSession}/SR.${meetingNo}`
    }

    getLisofSpeakers(speakers) {
      let _spekers = [];
      for(let speaker of speakers){
        _spekers.push(speaker.SP_entity.SP_entity);
      }
      return _spekers.join(',');
    }
    getSymbols(documents){
        let links = [];
        if(documents){
          for(let document of documents){
            links.push(`<a href="https://undocs.org/${this.symbolOnly(document.DD_symbol1)}"  aria-label="${document.DD_symbol1}" target="_blank" >${document.DD_symbol1}</a> <a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/meetings?document=${document.DD_symbol1}" aria-label="${document.DD_symbol1}" ><i class="fa fa-external-link"></i></a>`)
          }
          return links.join(',');
        }
        return '';
    }

    getMeetingReference(id) {
      return EnvironmentLoader.environment.meetingReference + id;
    }

    changeAccordianState() {
      this.panelOpenState = !this.panelOpenState;
    }

    getSponsorship(doc){
      const sub = this.meetingService.getSponserData(doc).subscribe((resp: any) => {
        this.showSponsorship = true;
        this.selectedSponsor = resp.result.length > 0 ? resp.result[0].sponsors.sort((a,b)=> a-b) : [];
      })
    }

    getVotes( id, type){

      this.selectedType = type;
      if(this.evotes[id]){
        this.singleEvote = this.evotes[id];
        let votinResult = this.singleEvote?.VT_VoteResults;
        if(votinResult){
          this.showVotes = true;
          this.selectedVotes = this.singleEvote;
        }
      }
      const sub = this.meetingService.getVotesData(id).subscribe((resp: any) => {
        this.evotes[id] = resp;
        this.singleEvote =  resp;
        let votinResult = this.singleEvote?.VT_VoteResults;
        if(votinResult){
          this.showVotes = true;
          this.selectedVotes = this.singleEvote;
        }
        sub.unsubscribe();
    });
    }
    modalClosed(status){
      this.showVotes= false;
      this.showSponsorship = false;
    }

    checkReferenceExist(meeting){
      let status = false;
      if(meeting.MT_jcmsMeetingId){
        return true;
      }
      if(meeting.MT_number && this.currentBody=='plenary'){
        return true;
      }
      if(meeting.MT_number && this.currentBody=='ffd4pc'){
        return false;
      }
      if(meeting.MT_number && this.currentBody!='plenary'){
        return true;
      }
      return false;
    }
    getOral(step){
        const {PS_oralChanges, PS_documentAmended} = step;
        let text = '';
        if(step.PS_type && step.PS_type.label == 'Statement to orally change'){
          return ''
        }
        if(PS_oralChanges.indexOf('Oral revision')> -1){
            text = 'as orally revised';
        }
        if(PS_oralChanges.indexOf('Oral correction')> -1){
            if(text !=''){
                text += ', as orally corrected';
            }
            else{
                text = 'as orally corrected';
            }
        }
        if(PS_oralChanges.indexOf('Oral amendment')> -1){
            if(text !=''){
                text += ', as orally amended';
            }
            else{
                text = 'as orally amended';
            }
        }
        if(PS_oralChanges.indexOf('As technically adjusted')> -1){
          if(text !=''){
              text += ', as technically adjusted';
          }
          else{
              text = 'as technically adjusted';
          }
      }
        if(PS_documentAmended == "True"){
          if(text==""){
            text ="as amended";
          }
          else{
            text +=" as amended";
          }
        }
        return text;
    }

    getStepText(step, segment){
      let documentSymbols = this.getSymbols(step.PS_selectDocumentFromWorkPackage);
      let text ='';
      if(!step.PS_type){
        return text;
      }
      switch(step.PS_type.label){
        case 'Document drawn attention to' :
          text = `Attention was drawn to document ${documentSymbols}`;
          break;
        case 'Statement on programme budget implications' :
          let text2 = step.PS_text1 !='' ? `(${step.PS_text1})` : step.PS_secondaryDocument ? `(${this.getSymbols(step.PS_secondaryDocument)})` : '';
          text = `Statement of Programme Budgetary Implications of ${documentSymbols} ${text2}`;
          break;
        case 'Withdrawal (Second Committee)' :
          text = `The proposal ${documentSymbols} was withdrawn`;
          break;
        case 'Agenda item status' :
          text = this.getAgendaWithStatus(step);
          break;
        case 'Document taken note of' :
          text = this.getPatargraph(step, segment);
          break;
        case 'Heading (iGov)':
          text = step.PS_text1;
          break;
        case 'Appointment':
          let _text = step.PS_text1 + ' ' + (step.PS_text2) || '' + ' '+ (step.PS_text3) || '';
          text = `Appointment: ${_text.trim()} ${this.getLisofSpeakerNamesWithFuncationTitleLater(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers)}`;
          break;
        case 'Election: by secret ballot (simple)':
          let _text1 = step.PS_text1 + ' ' + step.PS_text2 || '' + ' '+step.PS_text3 || '';
          text = `Election: by secret ballot: ${_text1.trim()} ${this.getLisofSpeakerNamesWithFuncationTitleLater(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers)}`;
          break;
        case 'Election: by acclamation':
          let _text2 = step.PS_text1 + ' ' + step.PS_text2 || '' + ' '+step.PS_text3 || '';
          text = `Election: by acclamation: ${_text2.trim()} ${this.getLisofSpeakerNamesWithFuncationTitleLater(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers)}`;
          break;
        case 'Election: proceed to':
          let _text3 = step.PS_text1 + ' ' + step.PS_text2 || '' + ' '+step.PS_text3 || '';
          text = `Election: proceed to ${_text3.trim()}`;
          break;
        case 'Election: ballot results (conclusive)':
          let _text4 = step.PS_text1 + ' ' + step.PS_text2 || '' + ' '+step.PS_text3 || '';
          text = `Election ballot results (conclusive): ${_text4.trim()}`;
          break;
        case 'Election: ballot result (inconclusive)':
          let _text5 = step.PS_text1 + ' ' + step.PS_text2 || '' + ' '+step.PS_text3 || '';
          text = `Election ballot results (inconclusive): ${_text5.trim()}`;
          break;
        
        case 'Statement by the presiding officer':
          if(this.checkTag(step.PS_tags, 'Response')){
            text = step.PS_type.label + " (response)";
          }
          else{
            text = step.PS_type.label;
          }
          break;
        case 'Statement by the Secretariat':
          if(this.checkTag(step.PS_tags, 'Response')){
            text = step.PS_type.label + " (response)";
          }
          else{
            text = step.PS_type.label;
          }
          break;
        case 'Statement by the Secretary-General':
          if(this.checkTag(step.PS_tags, 'Response')){
            text = step.PS_type.label + " (response)";
          }
          else{
            text = step.PS_type.label;
          }
          break;
        case 'Statements before adoption (Third Committee)':
          text = 'Statement(s) (before): '+this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true);
          break;
        case 'Statements after adoption (Third Committee)':
          text = 'Statement(s) (after): '+this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true);
          break;
        case 'Statements in explanation of vote before the vote':
          text = 'Explanation of vote (before): '+this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true);
          break;
        case 'Statements in explanation of vote after the vote':
          text = 'Explanation of vote (after): '+this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true);
          break;
        case 'Point of order':
          text = 'Point(s) of order: ' +this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true);
          break;
        case 'Right of reply' :
          text = `Right of reply: ${this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, true)}`;
          break;
        case 'Statements':
          let tagUsesd = false;
          if(this.checkTag(step.PS_tags,'Introductory statement')){
            tagUsesd=true;
            text = 'Introductory statement(s): '+this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
          }
          if(this.checkTag(step.PS_tags,'Statement and moderation')){
            tagUsesd=true;
            text = 'Statement and moderation: '+this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
          }
          if(this.checkTag(step.PS_tags,'Interactive discussion presenters responded')){
            tagUsesd=true;
            text = 'Interactive discussion presenters responded';
          }
          if(this.checkTag(step.PS_tags,'Interactive discussion')){
            tagUsesd=true;
            text = 'Interactive discussion: ' +this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, false, true);
          }
          if(this.checkTag(step.PS_tags,'Presentations')){
            tagUsesd=true;
            text = 'Presentations: ' +this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
          }
          if(this.checkTag(step.PS_tags,'NGO(s)')){
            tagUsesd=true;
            text = 'Statements (NGOs): ' +this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, false, true);
          }
          if(this.checkTag(step.PS_tags,'General discussion')){
            tagUsesd=true;
            text = 'General discussion: ' +this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, false, true);
          }
          if(this.checkTag(step.PS_tags,'Presentation')){
            tagUsesd=true;
            text = 'Presentations(s): ' +this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
          }
          if(this.checkTag(step.PS_tags,'Presentations')){
            tagUsesd=true;
            text = 'Presentations(s): ' +this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
          }
          if(this.checkTag(step.PS_tags,'Statements (observers)')){
            tagUsesd=true;
            text = 'Statements (observers): ' +this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers, false, true);
          }
          if(!tagUsesd && !step.PS_linkListOfSpeakers.RF_id && this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers)!=''){
            text = 'Statement(s): ' +this.getLisofSpeakerNames(step.PS_ListOfSpeakers, step.PS_linkListOfSpeakers);
          }
          break;

      }
      return text;
    }
    checkTag(tagList, tagName){
      return tagList.find(tag => tag.LKP_ValueShort == tagName);
    }
    getLisofSpeakerNames(speakers, PS_linkListOfSpeakers, onlyEntity = false, checkLevel=false) {
      let _spekers = [];
      for(let speaker of speakers){
        let slot = true;
        if(PS_linkListOfSpeakers && ((PS_linkListOfSpeakers.startSlot == '') || parseInt(speaker.SP_slotNo) >= parseInt(PS_linkListOfSpeakers.startSlot) && parseInt(speaker.SP_slotNo) <= parseInt(PS_linkListOfSpeakers.endSlot))){
          slot= false;
        }
        if(slot){
          continue;
        }
        let speakerName = [];
        if(checkLevel && speaker.SP_LS_lvlRepr && ['', 'Chair of Delegation', null].indexOf(speaker.SP_LS_lvlRepr.SP_LS_lvlRepr)>-1){
          onlyEntity= true;
        }
        if(speaker.SP_LS_lvlRepr && ['Head of State', 'Head of Government', 'Vice President', 'Crown Prince / Crown Princess', 'Deputy Prime Minister', 'Minister', 'Vice Minister', 'Acting Head of State', '', null].includes(speaker.SP_LS_lvlRepr.SP_LS_lvlRepr)){
          onlyEntity=false;
        }
        else{
          onlyEntity=true;
        }
        if(!onlyEntity){
          let title = speaker.SP_LS_funcTitle  ? speaker.SP_LS_funcTitle : '';
          if(title)
            speakerName.push(title)
          let name = `${speaker.SP_LS_title.SP_LS_title  || ''} ${speaker.SP_LS_fname || ''} ${speaker.SP_LS_lname  || ''}`;
          if(name.trim().length > 0 && name.trim() !='null')
            speakerName.push(name)
        }
        if(speaker.SP_entity.SP_entity)
          speakerName.push(speaker.SP_entity.SP_entity)
        if(Array.isArray(speaker.SP_LS_onbehalf) && speaker.SP_LS_onbehalf.length > 0){
          speakerName.push('on behalf of ' + speaker.SP_LS_onbehalf.join(' '))
        }
        else if(speaker.SP_LS_onbehalf.length > 0){
          speakerName.push('on behalf of ' + speaker.SP_LS_onbehalf)
        }
        _spekers.push(speakerName.join(', '));
      }
      return _spekers.join('; ');
    }
    getLisofSpeakerNamesWithFuncationTitleLater(speakers, PS_linkListOfSpeakers, onlyEntity = false, checkLevel=false) {
      let _spekers = [];
      for(let speaker of speakers){
        let slot = true;
        if(PS_linkListOfSpeakers && ((PS_linkListOfSpeakers.startSlot == '') || parseInt(speaker.SP_slotNo) >= parseInt(PS_linkListOfSpeakers.startSlot) && parseInt(speaker.SP_slotNo) <= parseInt(PS_linkListOfSpeakers.endSlot))){
          slot= false;
        }
        if(slot){
          continue;
        }
        let speakerName = [];
        if(checkLevel && ['', 'Chair of Delegation'].indexOf(speaker.SP_LS_lvlRepr.SP_LS_lvlRepr)>-1){
          onlyEntity= true;
        }
        if(!onlyEntity){
          
          let name = `${speaker.SP_LS_title.SP_LS_title  || ''} ${speaker.SP_LS_fname || ''} ${speaker.SP_LS_lname  || ''}`;
          if(name.trim().length > 0 && name.trim() !='null')
            speakerName.push(name)

          let title = speaker.SP_LS_funcTitle  ? speaker.SP_LS_funcTitle : '';
          if(title)
            speakerName.push(title)
        }
        if(speaker.SP_entity.SP_entity)
          speakerName.push(speaker.SP_entity.SP_entity)
        if(Array.isArray(speaker.SP_LS_onbehalf) && speaker.SP_LS_onbehalf.length > 0){
          speakerName.push('on behalf of ' + speaker.SP_LS_onbehalf.join(' '))
        }
        else if(speaker.SP_LS_onbehalf.length > 0){
          speakerName.push('on behalf of ' + speaker.SP_LS_onbehalf)
        }
        _spekers.push(speakerName.join(', '));
      }
      return _spekers.join('; ');
    }
    getAgendas(agendas){
      let links = [];
      if(agendas){
        for(let agenda of agendas){
          links.push(`<a href="${EnvironmentLoader.environment.localURL}/${this.lookupService.mainBodyURLValue(this.router.url)}/${this.currentBody}/${this.currentSession}/${agenda.item.replace('(', '').replace(')', '')}/meetings" aria-label="${'Item ' + agenda.item}">${'Item ' + agenda.item}</a>`)
        }
        return links.join(',');
      }
      return '';
  }
    getAgendaWithStatus(step){
      let items = this.getAgendas(step.PS_agenda);
      let status = '';
      switch(step.PS_agendaStatus){
        case 'begin':
          status ='began'
          break;
        case 'continue':
          status ='continued'
          break;
        case 'resume':
          status ='resumed'
          break;
        case 'keep open':
          status ='keep open'
          break;
        case 'conclude':
          status ='concluded'
          break;

      }
      if(status =='keep open'){
        return `Concluded this stage of ${items}`
      }
      return `The consideration of ${items} ${status}`
    }
}
